/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S11_Li2_LabelInputs */

const tr_onbilgi_s11_li2_label = /** @type {(inputs: Onbilgi_S11_Li2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desteklenen tarayıcılar (son 2 ana sürüm):`)
};

const en_onbilgi_s11_li2_label = /** @type {(inputs: Onbilgi_S11_Li2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supported browsers (last 2 major versions):`)
};

const de_onbilgi_s11_li2_label = /** @type {(inputs: Onbilgi_S11_Li2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützte Browser (die letzten 2 Hauptversionen):`)
};

const ru_onbilgi_s11_li2_label = /** @type {(inputs: Onbilgi_S11_Li2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддерживаемые браузеры (последние 2 основные версии):`)
};

/**
* | output |
* | --- |
* | "Supported browsers (last 2 major versions):" |
*
* @param {Onbilgi_S11_Li2_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s11_li2_label = /** @type {((inputs?: Onbilgi_S11_Li2_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S11_Li2_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s11_li2_label(inputs)
	if (locale === "de") return de_onbilgi_s11_li2_label(inputs)
	if (locale === "ru") return ru_onbilgi_s11_li2_label(inputs)
	return tr_onbilgi_s11_li2_label(inputs)
});